var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoCircle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.3686 16 16 12.3765 16 8C16 3.63137 12.3608 0 7.99216 0C3.61569 0 0 3.63137 0 8C0 12.3765 3.62353 16 8 16ZM8 14.6667C4.29804 14.6667 1.34118 11.702 1.34118 8C1.34118 4.30588 4.2902 1.33333 7.99216 1.33333C11.6863 1.33333 14.6588 4.30588 14.6667 8C14.6745 11.702 11.6941 14.6667 8 14.6667ZM7.92941 5.20784C8.50196 5.20784 8.94902 4.75294 8.94902 4.18824C8.94902 3.61569 8.50196 3.16078 7.92941 3.16078C7.35686 3.16078 6.9098 3.61569 6.9098 4.18824C6.9098 4.75294 7.35686 5.20784 7.92941 5.20784ZM6.61961 12.3137C6.30588 12.3137 6.0549 12.0863 6.0549 11.7647C6.0549 11.4588 6.30588 11.2157 6.61961 11.2157H7.6V7.61569H6.75294C6.43922 7.61569 6.18824 7.38824 6.18824 7.06667C6.18824 6.76078 6.43922 6.51765 6.75294 6.51765H8.23529C8.62745 6.51765 8.84706 6.8 8.84706 7.22353V11.2157H9.81961C10.1412 11.2157 10.3922 11.4588 10.3922 11.7647C10.3922 12.0863 10.1412 12.3137 9.81961 12.3137H6.61961Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/InfoCircle.d97cd1eee932b5205f96ef73dd880c6f.svg";